import { Typography } from '@musinsa/mds';
import type { FC } from 'react';
import type { PropsWithStyles } from '../../types';

export const OptionalPriceTag: FC<PropsWithStyles> = ({ ...rest }) => {
  return (
    <Typography colorScheme="gray-500" variant="textEtc11pxReg" {...rest}>
      옵션비 별도
    </Typography>
  );
};
